// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"342":"2a51707f","540":"f062942a","608":"b077664e","880":"8a3712f9","888":"58ca285b"}[chunkId] + ".css";
};